var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgVideo105 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 105,
  height: 105,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M30.5 10a.5.5 0 0 0 0 1h44a.5.5 0 0 0 0-1h-44ZM22 22.5a.5.5 0 0 1 .5-.5h60a.5.5 0 0 1 0 1h-60a.5.5 0 0 1-.5-.5ZM18.5 35a7.5 7.5 0 0 0-7.5 7.5v44a7.5 7.5 0 0 0 7.5 7.5h68a7.5 7.5 0 0 0 7.5-7.5v-44a7.5 7.5 0 0 0-7.5-7.5h-68Zm0-1a8.5 8.5 0 0 0-8.5 8.5v44a8.5 8.5 0 0 0 8.5 8.5h68a8.5 8.5 0 0 0 8.5-8.5v-44a8.5 8.5 0 0 0-8.5-8.5h-68Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--icon-decorative-coral)",
  fillRule: "evenodd",
  d: "M46.258 54.063a.5.5 0 0 1 .507.013l16 10a.5.5 0 0 1 0 .848l-16 10A.5.5 0 0 1 46 74.5v-20a.5.5 0 0 1 .258-.437Zm.742 1.34v18.195L61.557 64.5 47 55.402Z",
  clipRule: "evenodd"
})));
export { SvgVideo105 as ReactComponent };
export default __webpack_public_path__ + "8345d2220cc9fc365eeeb2594787c2c6.svg";